import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, createElementBlock as _createElementBlock, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-17ffc4f6"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onSubmit"]
const _hoisted_2 = ["value", "placeholder"]
const _hoisted_3 = ["src"]
const _hoisted_4 = ["src"]

import { ref, nextTick, computed } from 'vue';
  import { useI18n } from 'vue-i18n';
  import { isMobile } from '@/utils';

  export interface IProps {
    placeholder?: string;
    modelValue: string;
    scanner?: boolean;
  }
  export interface IEmits {
    (event: 'update:modelValue', keyword: string): void;
    (event: 'search', keyword: string): void;
    (event: 'scanner:change', content: string): void;
  }

  
export default /*#__PURE__*/_defineComponent({
  props: {
    placeholder: null,
    modelValue: null,
    scanner: { type: Boolean }
  },
  emits: ["update:modelValue", "search", "scanner:change"],
  setup(__props: any, { emit: emits }: { emit: ({
    (event: 'update:modelValue', keyword: string): void;
    (event: 'search', keyword: string): void;
    (event: 'scanner:change', content: string): void;
  }), expose: any, slots: any, attrs: any }) {

const props = __props as {
    placeholder?: string;
    modelValue: string;
    scanner?: boolean;
  }

  const { t } = useI18n();
  
  
  const input = ref();

  const showScanner = computed(() => {
    return props.scanner && isMobile();
  });

  const handleChange = (e: Event) => {
    const val = (e.target as HTMLInputElement).value;
    emits('update:modelValue', val);
  };

  const handleSearch = () => {
    emits('search', props.modelValue);
  };

  const handleEmptyKeyword = async () => {
    emits('update:modelValue', '');
    await nextTick();
    input.value.focus();
  };


return (_ctx: any,_cache: any) => {
  const _component_AppIconScan = _resolveComponent("AppIconScan")!
  const _component_AppScanner = _resolveComponent("AppScanner")!

  return (_openBlock(), _createElementBlock("form", {
    class: "search",
    onSubmit: _withModifiers(handleSearch, ["prevent"])
  }, [
    _createElementVNode("input", {
      ref_key: "input",
      ref: input,
      value: __props.modelValue,
      type: "text",
      placeholder: __props.placeholder || _unref(t)('placeholder'),
      onInput: handleChange
    }, null, 40, _hoisted_2),
    (_unref(showScanner))
      ? (_openBlock(), _createBlock(_component_AppScanner, {
          key: 0,
          onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('scanner:change', $event)))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_AppIconScan)
          ]),
          _: 1
        }))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _withDirectives(_createElementVNode("img", {
            class: "icon icon-search",
            src: require('@/assets/icon/search.png')
          }, null, 8, _hoisted_3), [
            [_vShow, !__props.modelValue]
          ]),
          _withDirectives(_createElementVNode("img", {
            class: "icon icon-delete",
            src: require('@/assets/icon/delete.png'),
            onClick: handleEmptyKeyword
          }, null, 8, _hoisted_4), [
            [_vShow, __props.modelValue]
          ])
        ], 64))
  ], 40, _hoisted_1))
}
}

})